export const LAST_STATUS = {
  A:   { label: 'Active',                   group: 'active',  base: 'A' },
  New: { label: 'New Listing',               group: 'active',  base: 'A' },
  Cs:  { label: 'Coming Soon',              group: 'pending', base: 'A' },
  Sld: { label: 'Sold',                     group: 'closed',  base: 'U' },
  Sc:  { label: 'Sold Cond.',               group: 'closed',  base: 'U' },
  Sce: { label: 'Sold Cond. w/ Escape',     group: 'closed',  base: 'U' },
  Lsd: { label: 'Leased',                   group: 'closed',  base: 'U' },
  Lc:  { label: 'Leased Cond.',             group: 'closed',  base: 'U' },
  Lce: { label: 'Leased Cond. w/ Escape',   group: 'closed',  base: 'U' },
  U:   { label: 'Off-Market',               group: 'default', base: 'U' },
  Ter: { label: 'Terminated',               group: 'default', base: 'U' },
  Exp: { label: 'Expired',                  group: 'default', base: 'U' },
  Pc:  { label: 'Price Change',             group: 'default', base: 'A' },
  Ext: { label: 'Extension',                group: 'default', base: 'A' },
  Inc: { label: 'Incomplete',               group: 'default', base: 'A' },
  Dft: { label: 'Deal Fell Through',        group: 'default', base: 'U' },
  Sus: { label: 'Suspended',               group: 'default', base: 'U' },
};

export const STATUS_HEX = {
  A:   '#2563eb',
  New: '#059669',
  Cs:  '#7c3aed',
  Sld: '#e11d48',
  Sc:  '#ea580c',
  Sce: '#d97706',
  Lsd: '#0d9488',
  Lc:  '#0891b2',
  Lce: '#0284c7',
  U:   '#64748b',
  Ter: '#6b7280',
  Exp: '#71717a',
  Pc:  '#4f46e5',
  Ext: '#8b5cf6',
  Inc: '#78716c',
  Dft: '#be123c',
  Sus: '#525252',
};

export const STATUS_BADGE_CLASS = {
  A:   'bg-blue-600 text-white hover:bg-blue-600',
  New: 'bg-emerald-600 text-white hover:bg-emerald-600',
  Cs:  'bg-violet-600 text-white hover:bg-violet-600',
  Sld: 'bg-rose-600 text-white hover:bg-rose-600',
  Sc:  'bg-orange-600 text-white hover:bg-orange-600',
  Sce: 'bg-amber-600 text-white hover:bg-amber-600',
  Lsd: 'bg-teal-600 text-white hover:bg-teal-600',
  Lc:  'bg-cyan-600 text-white hover:bg-cyan-600',
  Lce: 'bg-sky-600 text-white hover:bg-sky-600',
  U:   'bg-slate-500 text-white hover:bg-slate-500',
  Ter: 'bg-gray-500 text-white hover:bg-gray-500',
  Exp: 'bg-zinc-500 text-white hover:bg-zinc-500',
  Pc:  'bg-indigo-600 text-white hover:bg-indigo-600',
  Ext: 'bg-violet-500 text-white hover:bg-violet-500',
  Inc: 'bg-stone-500 text-white hover:bg-stone-500',
  Dft: 'bg-rose-700 text-white hover:bg-rose-700',
  Sus: 'bg-neutral-600 text-white hover:bg-neutral-600',
};

export const BADGE_GROUP_STYLES = {
  active:  'bg-emerald-600 text-white hover:bg-emerald-600',
  pending: 'bg-amber-500 text-white hover:bg-amber-500',
  closed:  'bg-slate-200 text-slate-700 hover:bg-slate-200',
  default: 'bg-gray-200 text-gray-700 hover:bg-gray-200',
};

export const PIN_GROUP_COLORS = {
  active:  '#059669',
  pending: '#d97706',
  closed:  '#64748b',
  default: '#94a3b8',
};

// Repliers standardStatus → { label, group }
// label:null means derive from isRental (Active/For Sale/For Rent)
export const STANDARD_STATUS = {
  'Active':                { label: null,                    group: 'active'  },
  'Active Under Contract': { label: 'Active Under Contract', group: 'pending' },
  'Pending':               { label: 'Pending',               group: 'pending' },
  'Coming Soon':           { label: 'Coming Soon',           group: 'pending' },
  'Closed':                { label: 'Sold',                  group: 'closed'  },
  'Leased':                { label: 'Leased',                group: 'closed'  },
  'Canceled':              { label: 'Canceled',              group: 'default' },
  'Expired':               { label: 'Expired',               group: 'default' },
  'Withdrawn':             { label: 'Withdrawn',             group: 'default' },
  'Hold':                  { label: 'On Hold',               group: 'default' },
  'Incomplete':            { label: 'Incomplete',            group: 'default' },
  'Delete':                { label: 'Deleted',               group: 'default' },
};

const _GROUP_HEX = {
  active:  STATUS_HEX.A,
  pending: STATUS_HEX.Cs,
  closed:  STATUS_HEX.Sld,
  default: STATUS_HEX.U,
};

const _GROUP_CLASS = {
  active:  STATUS_BADGE_CLASS.A,
  pending: STATUS_BADGE_CLASS.Cs,
  closed:  STATUS_BADGE_CLASS.Sld,
  default: STATUS_BADGE_CLASS.U,
};

export function isNewListing(listing) {
  return listing.daysOnMarket != null && listing.daysOnMarket <= 3;
}

export function getStatusMeta(lastStatus, apiStatus, isRental, standardStatus) {
  // standardStatus is authoritative for label and group
  if (standardStatus) {
    const stdEntry = STANDARD_STATUS[standardStatus];
    if (stdEntry) {
      const { group } = stdEntry;
      const label = stdEntry.label ?? (isRental ? 'For Rent' : 'For Sale');
      const hex = STATUS_HEX[lastStatus] ?? _GROUP_HEX[group] ?? STATUS_HEX.A;
      const className = STATUS_BADGE_CLASS[lastStatus] ?? _GROUP_CLASS[group] ?? STATUS_BADGE_CLASS.A;
      return { label, group, hex, className };
    }
  }
  // Fallback: derive from lastStatus code
  const entry = LAST_STATUS[lastStatus];
  const hex = STATUS_HEX[lastStatus] ?? (apiStatus === 'U' ? STATUS_HEX.U : STATUS_HEX.A);
  const className = STATUS_BADGE_CLASS[lastStatus] ?? (apiStatus === 'U' ? STATUS_BADGE_CLASS.U : STATUS_BADGE_CLASS.A);
  if (entry) {
    if (entry.group === 'active') {
      return { label: isRental ? 'For Rent' : 'For Sale', group: 'active', hex, className };
    }
    return { label: entry.label, group: entry.group, hex, className };
  }
  if (apiStatus === 'U') return { label: 'Off-Market', group: 'default', hex: STATUS_HEX.U, className: STATUS_BADGE_CLASS.U };
  return { label: isRental ? 'For Rent' : 'For Sale', group: 'active', hex: STATUS_HEX.A, className: STATUS_BADGE_CLASS.A };
}

// Filter token -> { base, codes[], baseMatch? }
// baseMatch:true → match all listings where apiStatus===base (Active/Off-Market umbrella)
export const FILTER_CODES = {
  A:   { base: 'A', codes: ['A', 'New'], baseMatch: true },
  New: { base: 'A', codes: ['New'] },
  Cs:  { base: 'A', codes: ['Cs'] },
  Sld: { base: 'U', codes: ['Sld', 'Sc', 'Sce'] },
  Lsd: { base: 'U', codes: ['Lsd', 'Lc', 'Lce'] },
  U:   { base: 'U', codes: ['U'], baseMatch: true },
  Ter: { base: 'U', codes: ['Ter'] },
  Exp: { base: 'U', codes: ['Exp'] },
  Sus: { base: 'U', codes: ['Sus'] },
};
